import React, { useEffect, useState } from "react";
import { Box, ClickAwayListener, makeStyles } from "@material-ui/core";
import AppColor from "utilities/AppColor";
import PropTypes from "prop-types";

import { useDispatch } from "react-redux";
import {
  getJobCalendar
} from "store/slices/job";
import Moment from "moment";
import { extendMoment } from 'moment-range';
import JobCalendar from "./JobCalendar";

const moment = extendMoment(Moment);

const styles = makeStyles(() => ({
  boxCalendar: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '0.5rem 0',
    '& i': {
      cursor: 'pointer'
    },
    '& span': {
      cursor: 'pointer'
    }
  },
  disabled: {
    opacity: 0.6,
    pointerEvents: 'none'
  },
  weeks: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid rgba(0, 0, 0, 0.2)',
    boxShadow: '0px 4px 4px rgb(0 0 0 / 25%)',
    position: 'absolute',
    width: '100%',
    background: AppColor.white,
    left: 0,
    textAlign: 'center',
    zIndex: 100,
    '& span': {
      margin: '0.3rem'
    }
  }
}));

const WorkerCalendarModal = (props) => {
  const {
    jobId,
    jobDetail,
    workersApplied,
    reloadJob
    // setShowBookingWorker
  } = props;
  const classes = styles();
  const dispatch = useDispatch();

  const [showListWeek, setShowListWeek] = useState(false);

  const [calendar, setCalendar] = useState([]);
  const [schedule, setSchedule] = useState([]);

  const [selectedWeek, setSelectedWeek] = useState();
  const [selectedYear, setSelectedYear] = useState();

  const [cacheSelectedWeek, setCacheWeek] = useState();

  const startDate = moment.utc(jobDetail.startDate).local().format('YYYY-MM-DD');
  const endDate = moment.utc(jobDetail.endDate).local().format('YYYY-MM-DD');
  useEffect(() => {
    if (selectedWeek || selectedWeek === 0) {
      _loadData();
    }
  }, [selectedWeek]);
  useEffect(() => {
    generateWeeks();
  }, [jobDetail]);

  useEffect(() => {
    if (cacheSelectedWeek && jobDetail) {
      setSelectedWeek(cacheSelectedWeek);
    }
  }, [cacheSelectedWeek, jobDetail]);

  const _loadData = async () => {
    const { firstWeekDay, lastWeekDay } = calendar[selectedWeek] || {};
    const newQueries = {};
    newQueries.startDate = moment(firstWeekDay).format('yyyy/MM/DD');
    newQueries.endDate = moment(lastWeekDay).format('yyyy/MM/DD');
    const result = await dispatch(getJobCalendar({ ...newQueries, jobId: jobId, }));
    const { payload } = result;
    if (payload) {
      setSchedule(payload);
    }
  };

  const generateWeeks = () => {
    const monthRange = moment.range(startDate, endDate);
    // // Get all the weeks during the current month
    let weeks = []
    for (const mday of monthRange.by('days')) {
      if (weeks.indexOf(mday.isoWeek()) === -1) {
        weeks = [...weeks, mday.isoWeek()];
      }
    }
    const startYear =  moment(startDate).year();
    let currentYear =  moment(startDate).year();
    let calendarArr = []
    let weeksNumber = weeks && weeks[0];
    for (let i = 0; i < weeks.length; i++) {
      if (weeks[i] < weeksNumber) {
        currentYear += 1;
      }
      weeksNumber = weeks[i]
      let firstWeekDay = moment().year(currentYear).isoWeek(weeks[i]).isoWeekday(1);
      // if (firstWeekDay.isBefore(startDate)) {
      //   firstWeekDay = startDate;
      // }

      let lastWeekDay = moment().year(currentYear).isoWeek(weeks[i]).isoWeekday(7);
      // if (lastWeekDay.isAfter(endDate)) {
      //   lastWeekDay = endDate;
      // }

      // document.write("<br>week number: " + index + " day: "+ firstWeekDay.format("DD-MM-YYYY")+" to "+ lastWeekDay.format("DD-MM-YYYY"))
      // let weekRange = moment.range(firstWeekDay, lastWeekDay)
      let weekRange = { firstWeekDay, lastWeekDay, weekNum: weeks[i] }
      calendarArr = [...calendarArr, weekRange];
    }
    setCalendar(calendarArr);
    const currentWeek = weeks.indexOf(moment().isoWeek());
    setSelectedWeek(currentWeek !== -1 ? currentWeek : 0);
    setSelectedYear(startYear)
  };

  const onChangeWeek = (weekNum) => {
    if (calendar[weekNum].firstWeekDay.year() !== selectedYear) {
      setSelectedYear(calendar[weekNum].firstWeekDay.year());
    }
    setSelectedWeek(weekNum);
  };

  const renderSelectedWeek = () => {
    const weekData = calendar[selectedWeek] || {};
    const { firstWeekDay, lastWeekDay } = weekData;
    return (
      <Box style={{ position: 'relative', padding: '0 1rem' }}>
        {
          showListWeek && (
            <ClickAwayListener
              onClickAway={() => setShowListWeek(false)}
            >
              <Box className={classes.weeks}>
                {
                  calendar.map((item, index) => {
                    const { firstWeekDay: fstWeekDay, lastWeekDay: lstWeekDay } = item;
                    return (<span
                      key={`calendar-${index}`}
                      onClick={() => selectedWeek !== index && onChangeWeek(index)}
                    >{`${fstWeekDay ? fstWeekDay.format("DD/MM") : ''} - ${lstWeekDay ? lstWeekDay.format("DD/MM") : ''}`}</span>)
                  })
                }
              </Box>
            </ClickAwayListener>

          )
        }
        <span onClick={() => setShowListWeek(true)}>{`${firstWeekDay ? firstWeekDay.format("DD/MM") : ''} - ${lastWeekDay ? lastWeekDay.format("DD/MM") : ''}`}</span>
      </Box>
    )
  };

  return (
    <Box>
      <Box className={classes.boxCalendar}>
        <i
          className={`fas fa-chevron-left mr-1 ${selectedWeek <= 0 ? classes.disabled : ''}`}
          onClick={() => selectedWeek > 0 && onChangeWeek(selectedWeek - 1)}
        ></i>
        {renderSelectedWeek()}
        <i
          className={`fas fa-chevron-right ml-1 ${selectedWeek + 1 >= calendar.length ? classes.disabled : ''}`}
          onClick={() => selectedWeek + 1 < calendar.length && onChangeWeek(selectedWeek + 1)}
        ></i>
      </Box>
      <Box>
        <JobCalendar
          startDate={moment(startDate).format('YYYY-MM-DD')}
          endDate={moment(endDate).format('YYYY-MM-DD')}
          calendar={calendar[selectedWeek]}
          schedule={schedule}
          workersApplied={workersApplied}
          setSelectedWeek={setCacheWeek}
          cacheSelectedWeek={selectedWeek}
          jobId={jobId}
          jobDetail={jobDetail}
          reloadCalendar={() => { _loadData() }}
          reloadJob={() => reloadJob() }
        />
      </Box>
    </Box>
  );
}

WorkerCalendarModal.propTypes = {
  jobId: PropTypes.any,
  jobDetail: PropTypes.any,
  setShowBookingWorker: PropTypes.any,
  workersApplied: PropTypes.any,
  reloadJob: PropTypes.any
};

export default WorkerCalendarModal;
